import React from 'react';

const Switch: React.FC<SwitchProps> = ({ isToggled, onClick, isDisabled }) => (
  <label className="switch">
    <input
      type="checkbox"
      checked={isToggled}
      onChange={onClick}
      disabled={isDisabled}
      style={{ appearance: 'none' }}
    />
    <span className={`super-admin-slider super-admin-round ${isDisabled ? 'disabled' : ''}`} />
  </label>
);

export default Switch;